<template>
  <div v-if="restockNeeded > 0">
    <v-sheet class="restock-box" color="#FAFAFA" elevation="2" rounded="lg">
      <!-- Header Row -->
      <v-row
        class="pa-2 align-center"
        style="background-color: #E4ECE2;"
      >
        <v-col cols="auto">
          <v-icon>mdi-alert-circle</v-icon>
        </v-col>
        <v-col>
          <span class="headline">{{ t('restock') }}</span>
        </v-col>
      </v-row>

      <!-- Content: Product Table -->
      <v-row style="max-height: 300px; overflow-y: auto; background-color: #FAFAFA;">
      <v-table class="pa-2">
        <thead>
          <tr>
            <th>{{ t('productNumber') }}</th>
            <th>{{ t('productName') }}</th>
            <th>{{ t('quantity') }}</th>
            <th>{{ t('minStock') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in restockProducts" :key="product.productNumber">
            <td>{{ product.productNumber }}</td>
            <td>{{ product.productName }}</td>
            <td>{{ product.qty }}</td>
            <td>{{ product.minStock }}</td>
          </tr>
        </tbody>
      </v-table>
      </v-row>
    </v-sheet>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const { t } = useI18n()
const store = useStore()

const restockNeeded = computed(() => store.state.dashboard.dashboardRestock.restockNeeded)
const restockProducts = computed(() => store.state.dashboard.dashboardRestock.restockItems)

const fetchLowStock = async () => {
  try {
    await store.dispatch('dashboard/fetchRestock')
  } catch (err) {
    console.error('Error fetching low stock products:', err)
  }
}

onMounted(() => {
  fetchLowStock()
})
</script>

<style scoped>
.restock-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  max-width: 450px;
  border-radius: 8px;
  z-index: 9999;
  background-color: #AAA;
}

.headline {
  font-size: 1.25rem;
  font-weight: 300;
}

v-table {
  width: 100%;
  border-collapse: collapse;
}

v-table th, v-table td {
  padding: 8px 0px;
  text-align: left;
}

v-table th {
  background-color: #f5f5f5;
}

v-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>